import { createFileRoute } from '@tanstack/react-router'
import { useSelector } from 'react-redux'
import HgCircularProgressGlobal from '@/common/components/ui/atoms/HgCircularProgressGlobal'
import PageNotFound from '@/common/components/views/PageNotFound'
import { titleTagSuffix } from '@/common/constants'
import { Helmet } from '@/common/components/Helmet'

export const Route = createFileRoute('/app/demos/')({
  component: RouteComponent,
})

function RouteComponent() {
  const appMeta = useSelector((state: any) => state.app_meta)
  const currentUser = useSelector((state: any) => state.auth.currentUser)
  const programs = useSelector((state: any) => state.programs)

  const ready = currentUser.bootstrapped && appMeta.loaded && programs.loaded

  if (!ready) {
    return <HgCircularProgressGlobal />
  }

  return (
    <>
      <Helmet>
        <title>Assessment Demo{titleTagSuffix}</title>
        <meta property="og:title" content="Assessment Demo" />
      </Helmet>
      <PageNotFound />
    </>
  )
}
